import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/live/:id",
    name: "live",
    component: () => import('@/views/live.vue')
  },
  {
    path: "/login",
    name: "login",
    component: () => import('@/views/login.vue')
  },
  {
    path: "/",
    redirect: "/profile"
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import('@/views/profile.vue')
  },
  {
    path: "/regression",
    name: "regression",
    component: () => import('@/views/regression.vue'),
  }
];
const router = new VueRouter({
  mode: 'history',
  routes
});

// 路由守卫
let whiteList = ['login'];
router.beforeEach((to, from, next) => {
  if(whiteList.indexOf(to.name)>=0){
    next();
  }else{
    let isAuthenticated = !!localStorage.getItem('user_token');
    if (!isAuthenticated){
      next({ name: 'login' });
    }else{
      next();
    }
  }
});

export default router;
